export default {
  type: 'object',
  properties: {
    0: {
      description: 'The main player info object',
      type: 'object',
      properties: {
        playerId: {
          type: ['string', 'number']
        },
        casinoId: {
          type: ['string', 'number']
        },
        playerStatus: {
          type: 'string'
        },
        email: {
          type: 'string'
        },
        emailOptIn: {
          type: 'string'
        },
        canPlayerChangeEmail: {
          type: 'string'
        },
        canPlayerChangePassword: {
          type: 'string'
        },
        name: {
          type: 'string'
        }
      }
    }
  },
  required: ['0']
};